/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Nothing_ChangedInputs */

const en_us2_profile_editors_nothing_changed = /** @type {(inputs: Profile_Editors_Nothing_ChangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing changed`)
};

const pt_br2_profile_editors_nothing_changed = /** @type {(inputs: Profile_Editors_Nothing_ChangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nada mudou`)
};

const es_419_profile_editors_nothing_changed = /** @type {(inputs: Profile_Editors_Nothing_ChangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nada cambió`)
};

const pt_pt2_profile_editors_nothing_changed = /** @type {(inputs: Profile_Editors_Nothing_ChangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nada mudou`)
};

const fr_fr2_profile_editors_nothing_changed = /** @type {(inputs: Profile_Editors_Nothing_ChangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rien n'a changé`)
};

const de_de2_profile_editors_nothing_changed = /** @type {(inputs: Profile_Editors_Nothing_ChangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nichts geändert`)
};

const it_it2_profile_editors_nothing_changed = /** @type {(inputs: Profile_Editors_Nothing_ChangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuna modifica`)
};

/**
* | output |
* | --- |
* | "Nothing changed" |
*
* @param {Profile_Editors_Nothing_ChangedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_nothing_changed = /** @type {((inputs?: Profile_Editors_Nothing_ChangedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Nothing_ChangedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_nothing_changed(inputs)
	if (locale === "es-419") return es_419_profile_editors_nothing_changed(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_nothing_changed(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_nothing_changed(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_nothing_changed(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_nothing_changed(inputs)
	return en_us2_profile_editors_nothing_changed(inputs)
});
export { profile_editors_nothing_changed as "profile-editors.nothing_changed" }